import { render, staticRenderFns } from "./SidePanelSkeleton.vue?vue&type=template&id=e136f5bc&"
import script from "./SidePanelSkeleton.vue?vue&type=script&lang=js&"
export * from "./SidePanelSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports